exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".style-module_spinner_3Hi4kUfCK_wpxHRlqSEBMB {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n}\n", "", {"version":3,"sources":["/root/app/src/components/Fetch/style.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;CACd","file":"style.module.css","sourcesContent":[".spinner {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"spinner": "style-module_spinner_3Hi4kUfCK_wpxHRlqSEBMB"
};